import { routeActions } from '@store/route/route.slice';
import { store } from '@store/store';

import { RouteInterface } from '@enum/route.enum';

export const pageNameLoader = (page: RouteInterface) => ({
  path: page.path,
  name: page.name,
  loader: () => {
    store.dispatch(routeActions.setRoute(page));
    return {};
  },
});
